import axios, { AxiosResponse } from 'axios';
import { AccountCompany } from 'contexts/account/types/account-company.type';
import { AccountUser } from 'contexts/account/types/account-user.type';





// GET
// /ewosapi/v1/me/logout
export const logout = async (): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(`/ewosapi/v1/me/logout`);
};

// GET
// /ewosapi/v1/me/revoke/token
/**
 * @deprecated Always returns 403 after /me/logout, which already revokes the current token. Use logout instead.
 */
export const revokeToken = async (): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(`/ewosapi/v1/me/revoke/token`);
};
